import { BadgeI } from "shared/ui/user-input/badge-input";

export const inputBadgesToString = (inputBadges: any) =>
  (inputBadges as unknown as Array<BadgeI>)?.map(({ value }) => value);
